export default __webpack_public_path__ + "static/media/grower-adviser-logo-white.13da45a0.png";